import { Stack, styled as muiStyled } from '@mui/material';
import { abyssColors } from '@/theme/colors';

export const Container = muiStyled(Stack)(() => ({
  background: abyssColors.primary[50],
  padding: '2.4rem 1.6rem',
  paddingBottom: '1.6rem',
  gap: '1.6rem',
  height: 'calc(100% - 4.8rem)',
  flex: 1,
  overflow: 'hidden',
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));

export const ScrollableContainer = muiStyled(Stack)(() => ({
  flex: 1,
  overflow: 'auto',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
  position: 'relative',
}));
